import type { TOC } from '@ember/component/template-only';

import MetricLibrarySourceComponent from 'webapp/components/metric-library/source/index';
import type MetricLibrarySourceController from 'webapp/controllers/metric-library/source';

interface Args {
	controller: MetricLibrarySourceController;
}

const MetricLibrarySourceRouteTemplate: TOC<Args> = <template>
	<MetricLibrarySourceComponent
		@sourceType={{@controller.model}}
		@source={{@controller.source}}
		@onSourceChange={{@controller.sendSourceChange}}
		@onAddMetricsToBoard={{@controller.sendAddMetricsToBoard}}
	/>
</template>;

export default MetricLibrarySourceRouteTemplate;
